import React, { useState } from "react";
import PageWrapper from "../components/PageWrapper";
import Colors from "../styles/Colors.json";
import { useSiteContext } from "../SiteContext";
import { downloadTimesheetDeadlineReport } from "../api/timesheetDeadlineReport";

const TimesheetDeadlineReportPage: React.FC = () => {
  const { translator, payPeriodID, payPeriods, setLoading, createPopup } = useSiteContext();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!payPeriodID || payPeriodID === 0) {
      createPopup("Error", "Please select a pay period to download the report.");
      return;
    }

    const currentPayPeriod = payPeriods.find((pp) => pp.PayPeriodID === payPeriodID);
    const weekNumber = currentPayPeriod?.WeekNumber ?? 0;
    const fileName = `TimesheetDeadlineReport_Week${weekNumber}.xlsx`;

    setIsDownloading(true);
    setLoading(true);

    try {
      await downloadTimesheetDeadlineReport(payPeriodID, fileName);
    } catch (error) {
      console.error("Error downloading timesheet deadline report:", error);
      createPopup("Error", "Failed to download timesheet deadline report. Please try again.");
    } finally {
      setIsDownloading(false);
      setLoading(false);
    }
  };

  return (
    <PageWrapper
      title={translator.translate("timesheetDeadlineReport")}
      backgroundColor={Colors.White}
      weekSelector={true}
    >
      <div style={{ padding: "16px" }}>
        <p>
          Select a pay period using the selector above, then click the button
          below to download the Timesheet Deadline Report as an Excel file.
        </p>
        <button
          className="report-generate-button"
          onClick={handleDownload}
          disabled={isDownloading || !payPeriodID || payPeriodID === 0}
        >
          {isDownloading ? "Downloading..." : "Download Timesheet Deadline Report"}
        </button>
      </div>
    </PageWrapper>
  );
};

export default TimesheetDeadlineReportPage;
